import { mkdir, lstat } from "fs"
import { promiseSequence } from "./promiseSequence.js"

// nodejs 10.12.0 https://nodejs.org/api/fs.html#fs_fs_mkdir_path_options_callback
// export const ensureFolderLeadingTo = (file) => {
//   return new Promise((resolve, reject) => {
//     fs.mkdir(path.dirname(file), { resurcive: true }, (error) => {
//       if (error) {
//         if (error.code === "EEXIST") {
//           resolve()
//           return
//         }
//         reject(error)
//         return
//       }
//       resolve()
//     })
//   })
// }

export const fileMakeDirname = (file) => {
  const fileNormalized = normalizeSeparation(file)
  // remove first / in case path starts with / (linux)
  // because it would create a "" entry in folders array below
  // tryig to create a folder at ""
  const fileStartsWithSlash = fileNormalized[0] === "/"
  const pathname = fileStartsWithSlash ? fileNormalized.slice(1) : fileNormalized
  const folders = pathname.split("/")
  folders.pop()

  return promiseSequence(
    folders.map((_, index) => {
      return () => {
        const folder = folders.slice(0, index + 1).join("/")
        return folderMake(`${fileStartsWithSlash ? "/" : ""}${folder}`)
      }
    }),
  )
}

const normalizeSeparation = (file) => file.replace(/\\/g, "/")

const folderMake = (folder) =>
  new Promise((resolve, reject) => {
    mkdir(folder, async (error) => {
      if (error) {
        // au cas ou deux script essayent de crée un dossier peu importe qui y arrive c'est ok
        if (error.code === "EEXIST") {
          const stat = await fileLastStat(folder)
          if (stat.isDirectory()) {
            resolve()
          } else {
            reject({ status: 500, reason: "expect a directory" })
          }
        } else {
          reject({ status: 500, reason: error.code })
        }
      } else {
        resolve()
      }
    })
  })

const fileLastStat = (path) =>
  new Promise((resolve, reject) => {
    lstat(path, (error, lstat) => {
      if (error) {
        reject({ status: 500, reason: error.code })
      } else {
        resolve(lstat)
      }
    })
  })
